import { holdsAdminHere, operatorWithoutAdmin } from './tenant-access.js';

/**
 * The part the signed-in account plays in the Compliance section, display only (the API enforces it):
 * 'operator' (health only: an operator account without the admin role on this customer, also while viewing as a
 * client, exactly like Notifications), 'admin', 'auditor', or null (no Compliance access).
 */
export function complianceRole(me, navClaims, customerId) {
  if (operatorWithoutAdmin(me, customerId)) return 'operator';
  if (navClaims?.admin === true || holdsAdminHere(me, customerId)) return 'admin';
  if (navClaims?.auditor === true) return 'auditor';
  return null;
}
